import {  FieldWrapper } from '@progress/kendo-react-form';
import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import SubHeader from '../components/SubHeader';
import { useHistory } from 'react-router-dom';
import img from '../images/letterOffer.png';
import img1 from '../images/letterOfOffer.png';
import imgStep from "../images/stepsLOO.png";
import helper from '../factory/Helper.js';
import storage from '../factory/StorageFactory';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import CusSavePrint from '../components/CusSavePrint';
import CusCancelApp from '../components/CusCancelApp'
import CusGreenBtn from '../components/CusGreenBtn'
import service from '../services/StatusEnquiryApiService';
import LoadingText from '../components/LoadingText';
import LOInstructions from '../components/LOInstructions.jsx';

const LetterOfOffer = (props) => {

    const compTypeLL = 'LL', compTypeLC = 'LC', compTypePCLS = 'PCLS';

    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);
    const [buttonPopup, setButtonPopup] = useState(false);

    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    let timer;

    useEffect(() => {
        console.log('@LetterOfOffer useEffect');

        window.scrollTo(0, 0);
        getPropsData();

        return () => clearTimeout(timer);
    }, []);

    const handleProceed = () => {
        if (config.SERVER_STATUS === "SIT" || config.SERVER_STATUS === "UAT" || config.SERVER_STATUS === "DEV") {
            history.push(config.route.FinanceDetails);

            setButtonPopup(false);
        } else {
            setButtonPopup(false);
        }
    };

    const detailsType = '1';

    const history = useHistory();

    const [isLoading, setIsLoading] = useState(true); //default true;
    const [isCancelling, setIsCancelling] = useState(false);

    const [isError, setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response, setResponse] = useState();

    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 5,
            fileName: refNo + '.pdf',
            proxyUrl: getProxyUrl()
        });
    };

    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('Submit');
        return url;
    }

    const exportPDFWithComponent = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
    };
    const printPDF = () => {
        window.print();
    }

    const getPropsData = () => {   //parse form preview or resume application 
        let resData = props.location.state.response? props.location.state.response:'';
 
        setResponse(resData);
        setRefNo(resData.StatusDtls.ApplicationNo);
        setUEN(resData.StatusDtls.UEN);
        setIsLoading(false);
    }

    const handleCancelApplication = () => {
        //do cancel api here.
        setIsCancelling(true);
        service.cancel(refNo,uen).then(res => {
            setIsCancelling(false);
            if (res.data.isSucess) {
                //cancel success
                setButtonPopup(false);
                props.history.push(config.route.AppCancelled);
            }
        })
        .catch(err => {
            console.log('err: ', err);
            setIsCancelling(false);
        })
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout()
    }

    const setErrMsgTimeout = () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const showBRDate = () => {
        if(response.Entity_Type_Code === compTypeLL || response.Entity_Type_Code === compTypeLC || response.Entity_Type_Code === compTypePCLS) {
            return true;
        }  
        else {
            return false;
        }
    }
    
    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo + '.pdf'}>
            <div className="container-fluid">
                <SubHeader title={'Letter of Offer'} /> <br />
                <FormContainer>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <img className="imgScc" src={img1} alt="imgScc1"></img>
                    </div>
                </FormContainer>
                <FormContainer>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <br/>
                       {showBRDate() &&
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <p className="cdbdtxtTitleYellow fbaPSize">We have received your confirmation of the Board Meeting Date</p>  
                            </div>
                        </div>
                        }
                        <br />
                        <img className='imgScc' src={img} alt='imgScc'></img>
                        <br />
                        <div className='bbline'>Letter of Offer (LO) Acceptance in progress</div><br />
                        {/* <div style={{ paddingTop: '-1.5em', fontSize: '0.7em' }}>Disbursement process will start once LO acceptance is completed.</div> */}
                        <br />
                        {/* removed dedoco steps */}
                        {/* <div style={{ textAlign: 'center' }} className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <hr className='hrgoldline hrsgold' />
                            </div>
                        </div> */}

                        {/* <img src={imgStep} alt='imgScc' style={{ marginTop: '-1em' }}></img> */}
                  
                        <LOInstructions />
                 
                        <br />
                    </div>
                    <FieldWrapper>
                        <CusSavePrint lb1='Save PDF' onClick1={exportPDFWithMethod} lb2='Print PDF' onClick2={printPDF} />
                        <br />
                        <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome}/>
                        <br/>
                        <CusCancelApp onClick={() => setButtonPopup(true)} pTrigger={buttonPopup} psetTrigger={setButtonPopup}
                            backClick={() => setButtonPopup(false)} nextClick={handleCancelApplication} />
                        <br />
                    </FieldWrapper>
                    <LoadingText show={isCancelling} setShow={setIsCancelling} label={'Cancelling..'} />
                </FormContainer>
            </div><br />
        </PDFExport>
    )
}

export default LetterOfOffer;